export function formatCurrency (number) {
    const normalized = Number(String(number ?? 0).replace(/,/g, ""));
      const formatted = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number.isNaN(normalized) ? 0 : normalized);

      return formatted
        .replace(/^\$/, "$ ")
        .replace(/^-\$/, "-$ ");
};